// store/middleware/saleItemsCacheMiddleware.ts
import { Middleware } from "@reduxjs/toolkit";
import { saveToStorage } from "../../common/utils/functions/localStorage";
import { selectAllSaleItems } from "../slices/saleItemListSlice";
import { getCacheVersion } from "../../config/runtimeConfig";

const SALE_ITEMS_ACTIONS = [
  "sale-item-list/setSaleItemList",
  "sale-item-list/updateItem",
  "sale-item-list/toggleFavorite",
  "sale-item-list/addRating",
  "sale-item-list/removeRating",
  "sale-item-list/markAsViewed",
];

export const saleItemsCacheMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    const result = next(action);

    if (action.type && SALE_ITEMS_ACTIONS.includes(action.type)) {
      const state = store.getState();
      const items = selectAllSaleItems(state);
      const total = state.saleItemList.total;

      // Сохраняем в формате, совместимом с API (массив, а не нормализованный объект)
      const cacheData = {
        data: items,
        total: total || items.length,
      };

      try {
        const version = getCacheVersion();
        const CACHE_KEY = `saleItemList_v${version}`;
        saveToStorage(CACHE_KEY, cacheData);
      } catch (error) {
        console.error("Ошибка сохранения кэша товаров:", error);
      }
    }

    return result;
  };